<article *ngIf="data">
  <h1 class="title">{{ data.title }}</h1>
  <div class="tags">
    <app-platform-tag *ngFor="let t of data.tags" [text]="t"></app-platform-tag>

    <div class="datetime">
      发布时间：
      <app-date [text]="data.published_time"></app-date>
    </div>
  </div>

  <div class="content" [innerHTML]="data.content"></div>
</article>
